// pages/GrazeBoxes/GrazeBoxDetails/DietarySelector.jsx
import React from "react";
import {
  Box,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";

const DietarySelector = ({
  dietaryOptions,
  selectedDiet,
  selectedSize,
  setDiet,
}) => {
  const handleChange = (_, newDietObj) => {
    if (newDietObj) setDiet(newDietObj); // <-- pass the full object
  };

  return (
    <Box sx={{ mt: 4, mb: 3 }}>
      <Typography fontWeight="bold" sx={{ mb: 1 }}>
        Dietary Restriction: {selectedDiet?.name}
      </Typography>

      <ToggleButtonGroup
        value={selectedDiet} // <-- object equality
        exclusive
        onChange={handleChange}
        sx={{ flexWrap: "wrap" }}>
        {dietaryOptions.map((option) => {
          const adj = option.priceAdjustments?.find(
            (x) => x.sizeId === selectedSize?.sizeId
          );
          const extra = adj?.amount || 0;
          return (
            <ToggleButton
              key={option.type}
              value={option} // <-- pass the object
              sx={{ textTransform: "capitalize", m: 0.5 }}>
              <Box textAlign="center">
                <Typography>{option.name}</Typography>
                {extra > 0 && (
                  <Typography variant="caption" color="text.secondary">
                    +${extra.toFixed(2)}
                  </Typography>
                )}
              </Box>
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
    </Box>
  );
};

export default DietarySelector;
